'use strict';

var legal = function () {
  var _getPriceLegal = function _getPriceLegal(dealersVehicle) {
    var area = dealersVehicle.dealer.territory.toLowerCase();
    var pvp = utils.formatPrice(dealersVehicle.prices.precioMostrar);
    var fuelType = dealersVehicle.vehicle.vcombustible.startsWith('El') ? 'electric' : 'combustion';

    var initialText = {
      portugal: 'PVP recomendado',
      madeira: 'PVP recomendado',
      acores: 'PVP recomendado'
    };

    var secondText = {
      portugal: {
        combustion: 'sem despesas administrativas e de transporte. Inclui ISV e IVA \xE0 taxa de ' + dealersVehicle.prices.iva + '%.',
        electric: 'sem despesas administrativas e de transporte inclui IVA \xE0 taxa de ' + dealersVehicle.prices.iva + '% e contempla a isen\xE7\xE3o de ISV.',
        region: 'Portugal Continental'
      },
      madeira: {
        combustion: 'sem despesas administrativas e de transporte. Inclui ISV e IVA \xE0 taxa de ' + dealersVehicle.prices.iva + '%.',
        electric: 'sem despesas administrativas e de transporte inclui IVA \xE0 taxa de ' + dealersVehicle.prices.iva + '% e contempla a isen\xE7\xE3o de ISV.',
        region: 'Madeira'
      },
      acores: {
        combustion: 'sem despesas administrativas e de transporte. Inclui ISV e IVA \xE0 taxa de ' + dealersVehicle.prices.iva + '%.',
        electric: 'sem despesas administrativas e de transporte inclui IVA \xE0 taxa de ' + dealersVehicle.prices.iva + '% e contempla a isen\xE7\xE3o de ISV.',
        region: 'A\xE7ores'
      }
    };

    var navaraText = dealersVehicle.vehicle.vmodelo.toLowerCase().includes('navara') ? '' : '';

    var priceRegistration = utils.formatPrice(dealersVehicle.prices.gastoMatriculacionEnvio);

    var registration = 'Inclui ' + priceRegistration + '\u20AC para despesas de matricula\xE7\xE3o e entrega ao domic\xEDlio e inclui custo da pintura.';

    var moreInfo = 'Informamos os utilizadores deste site, que apesar da inserção e actualização periódica de conteúdos, por parte da Nissan Ibéria S.A., todas as informações relativas aos modelos, são meramente indicativas, incluindo PVP, e não serão consideradas como constituintes de uma oferta contratual podendo ser alvo de alterações, não dispensando, assim, a consulta de um Concessionário da marca.';

    var images = 'As imagens apresentadas podem não coincidir totalmente com as especificações do veículo.';

    var _removeString = function _removeString(str) {
      return str.replace(' Não inclui despesas administrativas e transporte.', '').replace('Portugal Continental', secondText[area].region);
    };

    var offer = _removeString(dealersVehicle.prices.oferta.vnotaLegal);

    if (promoGalp.mustApplyDiscount()) offer = offer.replace('para particulares', 'para particulares Galp');

    var _getFinancialLegal = function _getFinancialLegal() {
      var resultStr = void 0;
      var financialType = dealersVehicle.prices.seleccionFinanciacion;
      switch (financialType.toLowerCase()) {
        case 'clasica':
          resultStr = _removeString(dealersVehicle.prices.ofertaFinanClasica.vnotaLegal);
          break;
        case 'mp3d':
          resultStr = _removeString(dealersVehicle.prices.ofertaFinanMP3D.vnotaLegal);
          break;
        default:
          resultStr = '';
      }

      if (promoGalp.mustApplyDiscount()) resultStr = resultStr.replace('para particulares', 'para particulares Galp');
      return resultStr;
    };

    var financialLegal = _getFinancialLegal();
    if (promoGalp.mustApplyDiscount()) financialLegal = financialLegal.replace('para particulares', 'para particulares Galp');

    /* const _getFinancialLegalRaw = (type) => {
      switch (type.toLowerCase()) {
        case 'clasica':
          return dealersVehicle.prices.ofertaFinanClasica.vnotaLegal
          break
        case 'mp3d':
          return dealersVehicle.prices.ofertaFinanMP3D.vnotaLegal
          break
        default:
          return ''
      }
    } */

    return {
      price: initialText[area] + ' (' + pvp + '\u20AC), ' + secondText[area][fuelType] + ' ' + navaraText,
      registration: registration,
      moreInfo: moreInfo,
      images: images,
      offer: offer,
      financialOffer: financialLegal /* ,
                                     financialOfferRaw: _getFinancialLegalRaw() */
    };
  };
  return {
    getPriceLegal: _getPriceLegal
  };
}();